import type { App, Directive } from 'vue';

import { vCopy } from './copy';
import { vResizableTextarea } from './resizableTextarea';

export { vCopy } from './copy';
export type { CopyBindingValue } from './copy';
export { vResizableTextarea } from './resizableTextarea';
export type { ResizableTextareaOptions } from './resizableTextarea';

const directives: Record<string, Directive> = {
  copy: vCopy,
  resizableTextarea: vResizableTextarea,
};

export function registerDirectives(app: App) {
  Object.entries(directives).forEach(([name, directive]) => {
    app.directive(name, directive);
  });
}
